import {
  PURCHASE_ORDERS,
  ADD_PURCHASE_ORDER,
  ADD_PURCHASE_ORDER_ERROR,
  PURCHASE_ORDER_DETAILS,
  DELETE_PURCHASE_ORDER,
  UPDATE_PURCHASE_ORDER,
  PURCHASE_ORDER_REPORTS,
} from "../types/PurchaseOrderType";
import { message } from "antd";

const initialState = {
  list: null,
  currentOrder: null,
  reports: null,
  pagination: null,
  loading: false,
  error: null,
};

const purchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_ORDERS:
      return {
        ...state,
        list: action.payload.orders || [],
        pagination: action.payload.pagination || null,
        loading: false,
      };

    case ADD_PURCHASE_ORDER:
      if (!Array.isArray(state.list)) {
        state.list = [];
      }
      const list = [...state.list];
      list.push(action.payload);
      return { ...state, list, loading: false };

    case PURCHASE_ORDER_DETAILS:
      return { ...state, currentOrder: action.payload.order, loading: false };

    case UPDATE_PURCHASE_ORDER:
      const updatedList = state.list?.map((order) =>
        order.id === action.payload.id ? action.payload : order
      ) || [];
      return {
        ...state,
        list: updatedList,
        currentOrder: action.payload,
        loading: false,
      };

    case DELETE_PURCHASE_ORDER:
      const filterOrders = state.list?.filter(
        (order) => order.id !== parseInt(action.payload) && order
      ) || [];
      return { ...state, list: filterOrders, loading: false };

    case PURCHASE_ORDER_REPORTS:
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.payload.reportType]: action.payload.data,
        },
        loading: false,
      };

    case ADD_PURCHASE_ORDER_ERROR:
      message.error(action.payload);
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default purchaseOrderReducer;
